import { rgb } from 'pdf-lib';

// This function converts pixels to millimeters
export const pixelsToMillimeters = (px) => px * 0.264583;

// This function converts points to millimeters
export const ptToMm = (pt) => pt * 25.4 / 72;

// This function calculates the height of a text block in millimeters
export const getTextBlockHeight = (doc, text, fontSize, maxWidth) => {
  doc.setFontSize(fontSize);
  const lines = doc.splitTextToSize(text, maxWidth);
  const lineHeight = ptToMm(fontSize) * 1.2;
  return { lines, height: lines.length * lineHeight };
};

// This function fixes the orientation of an image file by creating a new canvas
export const fixImageOrientation = async (file) => {
  const bitmap = await createImageBitmap(file);
  const isRotated = bitmap.width > bitmap.height;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (isRotated) {
    canvas.width = bitmap.height;
    canvas.height = bitmap.width;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(-90 * Math.PI / 180);
    ctx.drawImage(bitmap, -bitmap.width / 2, -bitmap.height / 2);
  } else {
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    ctx.drawImage(bitmap, 0, 0);
  }

  return canvas.toDataURL('image/jpeg');
};

// Helper function to place metadata text on a PDF-lib page
export function placeMetadataOnPage(page, metaText) {
  const { height } = page.getSize();
  page.drawText(metaText, {
    x: 20,
    y: height - 20,
    size: 10,
    color: rgb(0, 0, 0)
  });
}